<template>
  <v-dialog
    v-model="open"
    max-width="400"
    :persistent="persistent"
  >
    <v-card light class="body-2 text-xs-left grey--text text--darken-1 font-weight-medium">
      <v-card-title class="title" v-if="title">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <slot name="content"></slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          name="Close modal"
          class="font-weight-black"
          color="primary darken-2"
          flat="flat"
          @click="close()"
        >
          {{ buttonText ? buttonText : $t('actions.accept') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    triggerOpen: Boolean,
    title: String,
    buttonText: String,
    persistent: Boolean,
    redirectTo: String
  },
  methods: {
    close () {
      if (this.redirectTo) {
        this.$router.push({ name: this.redirectTo })
      } else {
        this.open = false
      }
    }
  },
  data () {
    return {
      open: false
    }
  },
  watch: {
    triggerOpen () {
      this.open = true
    }
  }
}
</script>
<style lang="scss">
.v-card {
  border-radius: 5px
}
</style>
